@if (appIcon(); as appIcon) {
  <ng-container style="vertical-align: middle">
    @if (appIcon.icon_primary && appIcon.icon_secondary) {
      <span [title]="title() || ''" class="fa-stack {{ size() ? 'fa-' + size() : '' }} {{ andClass() }}">
        <i
          class="fa {{ appIcon.icon_primary }} {{
            colorClassOverride() ? colorClassOverride() : ''
          }} fa-stack-1x fa-stack-right"
          style="opacity: 0.7"></i>
        <i
          class="fa {{ appIcon.icon_secondary }}
        {{ colorClassOverride() ? colorClassOverride() : 'fa-color-' + appIcon.icon_emphasis + ' ' }}
         fa-stack-2x fa-stack-right"></i>
      </span>
    }
    @if (!appIcon.icon_secondary) {
      <span [title]="title() || ''" class="fa-stack {{ size() ? 'fa-' + size() : '' }} {{ andClass() }}">
        <i
          class="fa {{ appIcon.icon_primary }} {{
            colorClassOverride() ? colorClassOverride() : 'fa-color-' + appIcon.icon_emphasis + ' '
          }} {{ size() ? 'fa-' + size() : '' }} fa-stack-1x"></i>
      </span>
    }
  </ng-container>
}
